export default function EFAddPower(props: any) {
    return (
        <svg width="100%" height="100%" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient x1="-5.7909481%" y1="28.8843533%" x2="100%" y2="72.9158363%" id="linearGradient-1">
                    <stop stopColor="#FFDC7E" offset="0%"></stop>
                    <stop stopColor="#FFD35B" offset="40.7071276%"></stop>
                    <stop stopColor="#FFC520" offset="100%"></stop>
                </linearGradient>
            </defs>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-52.000000, -1379.000000)" fill="url(#linearGradient-1)">
                    <g transform="translate(40.000000, 1367.000000)">
                        <g transform="translate(12.000000, 10.000000)">
                            <path d="M8,2 C12.418278,2 16,5.581722 16,10 C16,14.418278 12.418278,18 8,18 C3.581722,18 0,14.418278 0,10 C0,5.581722 3.581722,2 8,2 Z M8.53333333,6.8 L7.46666667,6.8 L7.466,9.466 L4.8,9.46666667 L4.8,10.5333333 L7.466,10.533 L7.46666667,13.2 L8.53333333,13.2 L8.533,10.533 L11.2,10.5333333 L11.2,9.46666667 L8.533,9.466 L8.53333333,6.8 Z"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
